const PRODUCT_TYPES = {
  DEFAULT: 'Físico',
  DIGITAL: 'Digital',
};

const PRODUCT_TYPES_ENUM = Object.keys(PRODUCT_TYPES);

const DEFAULT = PRODUCT_TYPES_ENUM[0];
const DIGITAL = PRODUCT_TYPES_ENUM[1];

export {
  PRODUCT_TYPES,
  PRODUCT_TYPES_ENUM,
  DEFAULT,
  DIGITAL,
};
